export default "__VITE_ASSET__kBSxHI5h__"